import {
  Component,
  OnInit,
  ChangeDetectorRef,
  ViewChild,
  ElementRef,
  Renderer2,
  ViewEncapsulation,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DateTime, Zone } from 'luxon';
import { GeneralService } from '../../../../services/general/general.service';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-index',
  templateUrl: './index.component.html',
  styleUrls: ['../../../../../shared-styles/dashboard.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class IndexComponent implements OnInit {
  public isMobile: any;
  public headerHeight: any = 0;
  public loading: any = false;
  public subscriptions: any = [];
  public nextClass: any = null;
  public nextClassButton = false;
  public testClasses = 0;
  public listedClasses : any;

  public user: any;
  public userInfo: any;

  nextClassStart: any;
  nextClassEnd: any;
  currentLocale: string | null;

  public groupalListMine: any;

  constructor(
    public general: GeneralService,
    private cdRef: ChangeDetectorRef,
    private renderer: Renderer2,
    private formBuilder: FormBuilder,
    private _router: Router,
    private _route: ActivatedRoute
  ) {

    this.isMobile = this.general.isMobile();

    this.currentLocale = this.general.getCurrentLocale();
  }

  async ngOnInit() {
    try {
      this.general.setLoading(true);
      this.intializeSubscriptions();
      await this.getUserInfo();
      await this.getInitialData();
      await this.checkTimeToClass();
      this.getGrupalClassesFiltered();
    } catch (error) {
      // teacher-class-mine
    } finally {
      this.general.setLoading(false);
    }
    this.getGroupalMine();
  }

  
  ngOnDestroy() {
    this.subscriptions.forEach((subscription: any) => {
      subscription.unsubscribe();
    });
  }

  intializeSubscriptions() {
    this.subscriptions = [
      this.general.loading$.subscribe((res) => (this.loading = res)),
    ];
  }

  async getGrupalClassesFiltered () {

    try {
      this.general.setLoading(true);
      const response = await this.general.httpPost('groupal-class-list',{lesson_id: this.user.student_lesson_id,});
      this.listedClasses = response.message;  
    } catch (error) {
    } finally {
      this.general.setLoading(false);
    }
    
  }     

  async getUserInfo() {
    const response = await this.general.getUserInfo();
    this.userInfo = response.data;
    this.user = this.userInfo.user;
  }

  async getInitialData() {
    const requests = [
      this.general.httpGet('next-class'),
      this.general.httpGet('student-free-hours'),
       this.general.httpGet('student-free-hours'),

    ];
    const response: any = await this.general.forkJoin(requests);
    this.nextClass = response[0];
    //Get test classes from endpoint
    this.testClasses = response[1].data.quantity;
    if (!this.nextClass) {
      return;
    }
    const timezone = this.general.getCurrentTimezone();
    this.nextClass.start = DateTime.fromFormat(this.nextClass.start,'yyyy-LL-dd HH:mm:ss',{zone: 'UTC',}).setZone(timezone);
    this.nextClassStart = this.nextClass.start.setLocale(this.currentLocale).toFormat('dd/MM/yyyy HH:mm');
    this.nextClass.end = DateTime.fromFormat(this.nextClass.end,'yyyy-LL-dd HH:mm:ss',{zone: 'UTC',}).setZone(timezone);
    this.nextClassEnd = this.nextClass.end.setLocale(this.currentLocale).toFormat('dd/MM/yyyy HH:mm');
  }

  async getGroupalMine() {
    const response = await this.general.httpPost('groupal-class-mine-list',{});
    this.groupalListMine = response.message;
    this.groupalListMine = this.groupalListMine.map((e: any) => {
      const timezone = this.general.getCurrentTimezone();
      e.date = DateTime.fromFormat(e.dateHour,'yyyy-LL-dd HH:mm:ss',{zone: 'UTC',}).setZone(timezone);
      e.date = e.date.setLocale(this.currentLocale).toFormat('dd/MM/yyyy');
      e.hour = DateTime.fromFormat(e.dateHour,'yyyy-LL-dd HH:mm:ss',{zone: 'UTC',}).setZone(timezone);
      e.hour = e.hour.setLocale(this.currentLocale).toFormat('HH:mm');
      return e;
      });
  }

  async rejectGroupalInvitation(id :any) {
    
    const response = await this.general.httpPost('groupal-class-mine-reject',{groupal_class_id: id});

    if (response.success==true) {
      // mostrar emergente rechazado correctamente y recargar
      await this.general.showDanger('Se ha rechazado correctamente la asistencia la clase grupal');
      await this.getGroupalMine();
    }
    
    
  }

  async checkTimeToClass() {
    if (!this.nextClass) {
      return;
    }
    const timezone = this.general.getCurrentTimezone();
    const now = DateTime.local().setZone(timezone);

    const start = this.nextClass.start;
    const end = this.nextClass.end;

    this.nextClassButton = start.toMillis() < end.toMillis();

    // this.nextClassButton = now.toMillis() + 1000 * 60 * 60 * 2 > end.toMillis();
  }

  async onSelectFile(event: any) {
    try {
      if (event.files.item(0)) {
        const photo = event.files.item(0);
        const formData: any = new FormData();
        formData.append('profile_photo_path', photo);
        const response = await this.general.httpPost('update-photo', formData);
        if(response){
          const $source: any = document.getElementById('dashboard-photo');
          $source.setAttribute('src', URL.createObjectURL(photo));
        }
      }
 
    } catch (error) {
      await this.general.showDanger('photo_error_upload');
    }
  }

}